import { render, staticRenderFns } from "./BlogYearSelect.vue?vue&type=template&id=8ef749a2&scoped=true&"
import script from "./BlogYearSelect.vue?vue&type=script&lang=js&"
export * from "./BlogYearSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef749a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
